import React from "react";
import DownloadZoomIllustration from "public/assets/kelas-live/download-zoom-illustration.svg";
import {
  ZoomAccessInfoContainer,
  ZoomAccessInfoImageWrapper,
  ZoomAccessInfoMessage,
  ZoomAccessInfoCTA
} from "./zoom-access-info.styles";
import Image from "next/legacy/image";

const ZoomAccessInfo: React.FC = () => {
  return (
    <ZoomAccessInfoContainer>
      <ZoomAccessInfoImageWrapper>
        <Image
          src={DownloadZoomIllustration}
          alt="Download Zoom"
          layout="fill"
        />
      </ZoomAccessInfoImageWrapper>
      <ZoomAccessInfoMessage>
        Download Zoom dulu di laptop sebelum kelas, ya!
      </ZoomAccessInfoMessage>

      <ZoomAccessInfoCTA
        href=" https://zoom.us/support/download"
        rel="noopener noreferrer"
        target="_blank"
      >
        Download Zoom
      </ZoomAccessInfoCTA>
    </ZoomAccessInfoContainer>
  );
};

export { ZoomAccessInfo };
